export const FilterKey = {
	optionId: "option-id" as const,
} as const;
